<form *ngIf="form" [formGroup]="form" class="mat-typography">

    <mat-error *ngIf="error">{{error}}</mat-error>
    <table>
        <tr>
            <th>
                Field
            </th>

            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>

        <tr>
            <td>
                State
            </td>

            <td>
                {{data?.state}}
            </td>

            <td>

                <mat-form-field appearance="fill">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="state">
                        <mat-option [value]="'enabled'">Enabled</mat-option>
                        <mat-option [value]="'disabled'">Disabled</mat-option>
                    </mat-select>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status [hasError]="form.get('state').value !== data?.state"></sway-baseline-status>
            </td>
        </tr>



        <tr>
            <td>
                <div class="info-wrapper">
                    Allow use of Microsoft Authenticator OTP

                    <mat-icon matTooltip="Allow use of Microsoft Authenticator OTP">info</mat-icon>
                </div>
            </td>

            <td>
                {{data?.isSoftwareOathEnabled ? 'Yes' : 'No'}}
            </td>

            <td>

                <mat-form-field appearance="fill">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="isSoftwareOathEnabled">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status
                    [hasError]="errorsString.includes('isSoftwareOathEnabled')"></sway-baseline-status>
            </td>
        </tr>
    </table>

    <div class="mt-4">
        <app-authentication-method-policy-targets
            [readOnly]="readOnly"
            [includeOptionsLookups]="includeOptionsLookups"
            [groups]="groups$ | async" [tenantId]="tenant_id" [form]="form" [policy]="data"
            [item]="baselineTemplateItem" [errorsString]="errorsString"></app-authentication-method-policy-targets>
    </div>




    <app-microsoft-authentication-feature-setting-item
        [errorsString]="errorsString"
        [groups]="groups$ | async" [graphGroups]="graphGroups$ | async"
        [form]="form" [featureSettings]="data?.featureSettings" [item]="'displayAppInformationRequiredState'"
        [title]="'Show application name in push and passwordless notifications'"
        [hint]="'Note: If the feature status is set to Microsoft-managed, it will be enabled by Microsoft at an appropriate time after the preview.'">


    </app-microsoft-authentication-feature-setting-item>

    <app-microsoft-authentication-feature-setting-item
        [errorsString]="errorsString"
        [groups]="groups$ | async" [graphGroups]="graphGroups$ | async"
        [form]="form" [featureSettings]="data?.featureSettings" [item]="'displayLocationInformationRequiredState'"
        [title]="'Show geographic location in push and passwordless notifications'"
        [hint]="'Note: If the feature status is set to Microsoft-managed, it will be enabled by Microsoft at an appropriate time after the preview.'">
    </app-microsoft-authentication-feature-setting-item>


    <app-microsoft-authentication-feature-setting-item
        [errorsString]="errorsString"
        [groups]="groups$ | async" [graphGroups]="graphGroups$ | async"
        [form]="form" [featureSettings]="data?.featureSettings" [item]="'companionAppAllowedState'"
        [title]="'Microsoft Authenticator on companion applications'"
        [hint]="'Note: If the feature status is set to Microsoft-managed, it will be enabled by Microsoft at an appropriate time after the preview.'">

    </app-microsoft-authentication-feature-setting-item>
</form>
